import { fontSize, fontWeight, letterSpacing } from '@/src/core/utils/typography';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';

export interface EmptyStateProps {
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
  action?: {
    label: string;
    onPress: () => void;
  };
  colors: {
    textSecondary: string;
    textTertiary: string;
    primary?: string;
  };
}

export const EmptyState = ({ title, subtitle, icon, action, colors }: EmptyStateProps) => {
  return (
    <View style={styles.container}>
      {icon && <View style={styles.icon}>{icon}</View>}
      <Text style={[styles.title, { color: colors.textSecondary }]}>{title}</Text>
      {subtitle && <Text style={[styles.subtitle, { color: colors.textTertiary }]}>{subtitle}</Text>}
      {action && (
        <TouchableOpacity
          style={[styles.actionButton, { borderColor: colors.primary ?? '#007AFF' }]}
          onPress={action.onPress}
        >
          <Text style={[styles.actionLabel, { color: colors.primary ?? '#007AFF' }]}>
            {action.label}
          </Text>
        </TouchableOpacity>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    paddingVertical: 60,
    paddingHorizontal: 20,
  },
  icon: {
    marginBottom: 16,
  },
  title: {
    fontSize: fontSize.lg,
    fontWeight: fontWeight.semibold,
    letterSpacing: letterSpacing.tight,
    marginBottom: 6,
    textAlign: 'center',
  },
  subtitle: {
    fontSize: fontSize.base,
    lineHeight: 20,
    textAlign: 'center',
  },
  actionButton: {
    marginTop: 20,
    paddingHorizontal: 20,
    paddingVertical: 10,
    borderRadius: 8,
    borderWidth: 1.5,
  },
  actionLabel: {
    fontSize: fontSize.body,
    fontWeight: fontWeight.semibold,
    letterSpacing: letterSpacing.wide,
  },
});
